import { useRequest } from 'features/request/useRequest';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { checkIsUniqueInternalNumber } from '../AgreementsQueries';

export const useIsUniqueContractChangeInternalNumber = ({
    contractId,
    newInternalNumber,
    contractChangeId,
    isCreating,
}: {
    contractId: number;
    newInternalNumber: string;
    contractChangeId: number | null | undefined;
    isCreating: boolean;
}): boolean => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            contractChangeId: isCreating ? null : contractChangeId,
            number: newInternalNumber,
            contractId,
        }),
        [contractChangeId, contractId, isCreating, newInternalNumber],
    );

    const [isUniqueData, , , isUniqueRequest] = useRequest({
        requestId: 'isUniqueContractChangeInternalNumber',
        query: checkIsUniqueInternalNumber,
        variables,
        withEffect: false,
    });

    const debounceCheck = useDebounce(() => {
        if (newInternalNumber) {
            dispatch(isUniqueRequest(variables));
        }
    }, 500);

    useEffect(() => debounceCheck(), [debounceCheck, newInternalNumber]);

    return isUniqueData?.uerIsUniqueContractChangeInternalNumber?.result;
};
